<form class="dynamic-form" [formGroup]="form" (submit)="onSubmit($event)">
    <ng-container *ngFor="let field of formFields;">
        <ng-container  *ngIf="field.type !== 'label' && canRender(field)" (change)="onChange($event)" dynamicField [field]="field" [group]="form">
        </ng-container>
        <div  *ngIf="field.type == 'label'" [innerHtml]="field.label">
        </div>
    </ng-container>
</form>